<template>

    <div id="navigation-wrapper">
       
        <!-- LOGO -->
        <router-link :to="{ name: homeLink }" id="logo"></router-link>

        <!-- NAVIGATION -->
        <nav :class="['menu', { 'menuClosed' : !isMenuOpen}]" :key="userRole">

            <ul class="menu-list">

                <!-- APOTHEKEN -->
                <router-link tag="li" :to="{ name: 'apotheken' }" title="Apotheken" v-if="can('SITES')">
                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-apotheken"></i></span>
                        <lang labelKey="MAIN_MENU-PHARMACIES"></lang>
                    </a>
                </router-link>

                <!-- APOTHEKEN KATALOG -->
                <router-link tag="li" :to="{ name: 'catalog' }" title="Apotheken Katalog" v-if="can('CATALOG')">

                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-katalog"></i></span>
                        <lang labelKey="MAIN_MENU-CATALOG"></lang>
                    </a>

                    <ul class="subNav">

                        <!-- Apotheken Liste -->
                        <router-link tag="li" :to="{ name: 'catalogPharmacies' }" title="Apotheken">
                            <a>
                                <lang labelKey="MAIN_MENU-PHARMACIES"></lang>
                            </a>
                        </router-link>

                        <!-- PRODUCTS -->
                        <router-link tag="li" :to="{ name: 'produkte' }" title="Produkte" v-if="can('PRODUCTS')">
                            <a>
                                <lang labelKey="MAIN_MENU-PRODUCTS"></lang>
                            </a>
                        </router-link>

                        <!-- Online Lexicon -->
                        <router-link tag="li" :to="{ name: 'catalogOnlineLexicon' }">
                            <a>
                                <lang labelKey="MAIN_MENU-CATALOG-LEXICON"></lang>
                            </a>
                        </router-link>

                        <template v-if="can('SETTINGS')">

                            <!-- HERSTELLER -->
                            <router-link tag="li" :to="{ name: 'settingsManufacturers' }" v-if="can('MANUFACTURERS')">
                                <a>
                                    <lang labelKey="MAIN_MENU-SETTINGS_MANUFACTURERS"></lang>
                                </a>
                            </router-link>

                            <!-- RUBRIKEN -->
                            <router-link tag="li" :to="{ name: 'settingsSections' }" v-if="can('CATALOG_SECTIONS')">
                                <a>
                                    <lang labelKey="MAIN_MENU-SETTINGS_SECTIONS"></lang>
                                </a>
                            </router-link>

                            <!-- MONITORING -->
                            <router-link tag="li" :to="{ name: 'monitoring' }" title="Monitoring"
                                v-if="can('MONITORING')">
                                <a>
                                    <lang labelKey="MAIN_MENU-MONITORING"></lang>
                                </a>
                            </router-link>

                            <!--  Settings -->
                            <router-link tag="li" :to="{ name: 'catalogSettings' }">
                                <a>
                                    <lang labelKey="MAIN_MENU-CATALOG-SETTINGS"></lang>
                                </a>
                            </router-link>

                        </template>


                    </ul>

                </router-link>


                <!-- APOPOINT -->
                <router-link tag="li" :to="{ name: 'apopoint' }" title="Apopoint" v-if="can('PIM') && !activeUser.site && activeUser.userRole.name !== 'Sanova Manager'">
                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-goto-cms"></i></span>
                        <lang labelKey="MAIN_MENU-APOPOINT"></lang>
                    </a>

                    <ul class="subNav">

                        <router-link tag="li" :to="{ name: 'apopoints' }">
                            <a>
                                <lang labelKey="MAIN_MENU-APOPOINTS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'primBrands' }" v-if="activeUser.userRole.name == 'Administrator JTM'  /*|| activeUser.userRole.name == 'Administrator' || */">
                            <a>
                                <lang labelKey="MAIN_MENU-BRANDS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'pimProducts' }">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-PRODUCTS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'pimCampaigns' }">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-CAMPAIGNS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'pimProductGroups' }">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-PRODUCT_GROUPS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'pimSettings' }" v-if="activeUser.userRole.name == 'Administrator'">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-PHARMACY_SETTINGS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'apopointCC' }" v-if="activeUser.userRole.name == 'Administrator JTM'">
                            <a>
                                <lang labelKey="MAIN_MENU-APOPOINT-CONTROL_CENTER"></lang>
                            </a>
                        </router-link>
                    </ul>

                </router-link>

                <!-- APOPOINT (ROLE SANOVA MANAGER)-->
                <router-link tag="li" :to="{ name: 'apopoint' }" title="Apopoint" v-if="activeUser.userRole.name === 'Sanova Manager'">
                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-goto-cms"></i></span>
                        <lang labelKey="MAIN_MENU-APOPOINT"></lang>
                    </a>

                    <ul class="subNav">

                        <router-link tag="li" :to="{ name: 'apopoints' }">
                            <a>
                                <lang labelKey="MAIN_MENU-APOPOINTS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'primBrands' }">
                            <a>
                                <lang labelKey="MAIN_MENU-BRANDS"></lang>
                            </a>
                        </router-link>
                        <router-link tag="li" :to="{ name: 'pimProducts' }">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-PRODUCTS"></lang>
                            </a>
                        </router-link>
                    </ul>
                </router-link>   


                <!-- SANOVA ASSET MANAGER -->
                <router-link tag="li" :to="{ name: 'sanovaAssetManager' }" title="Sanova Asset Manager" v-if="activeUser.userRole.name == 'Administrator JTM' || /* activeUser.userRole.name == 'Administrator' || */ activeUser.userRole.name == 'Sanova Manager'">

                    <a>
                        <span class="icon is-small"><i class="fa fa-file-image-o"></i></span>
                        <lang labelKey="MAIN_MENU-SANOVA_ASSET_MANAGER"></lang>
                    </a>
                    <ul class="subNav">

                        <router-link tag="li" :to="{ name: 'sam-assets' }">
                            <a>
                                <lang labelKey="MAIN_MENU-SAM-ASSETS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'sam-asset_groups' }">
                            <a>
                                <lang labelKey="MAIN_MENU-SAM-ASSET_GROUPS"></lang>
                            </a>
                        </router-link>

                    </ul>
                </router-link>


                <!-- MARKETING COCKPIT -->
                <router-link tag="li" :to="{ name: 'marketingCockpit' }" title="Marketing Cockpit"
                    v-if="can('CALENDAR')
                        || activeUser.username == 'ej'
                        || (activeUser.site && activeUser.site.newsletter && can('SITE_NEWSLETTER')) || can('NEWSLETTER')
                        || (activeUser.site && activeUser.site.socialMedia && can('SITE_SOCIAL_MEDIA')) || can('SOCIAL_MEDIA')">
                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-social-media"></i></span>
                        <lang labelKey="MAIN_MENU-MARKETING_COCKPIT"></lang>
                    </a>

                    <ul class="subNav">

                        <!-- CALENDAR -->
                        <router-link tag="li" :to="{ name: 'calendar' }" title="Kalender"
                            v-if="can('CALENDAR') || activeUser.username == 'ej'">
                            <a>
                                <lang labelKey="MAIN_MENU-CALENDAR"></lang>
                            </a>
                        </router-link>

                        <!-- NEWSLETTER -->
                        <router-link tag="li" :to="{ name: 'newsletter' }" title="Newsletter" key="newsletter"
                            v-if="activeUser.site && activeUser.site.newsletter && can('SITE_NEWSLETTER') || can('NEWSLETTER')">
                            <a>
                                <lang labelKey="MAIN_MENU-NEWSLETTER"></lang>
                            </a>
                        </router-link>

                        <!-- SOCIAL MEDIA -->
                        <router-link tag="li" :to="{ name: 'socialMedia' }" title="Social Media" key="socialMedia"
                            v-if="activeUser.site && activeUser.site.socialMedia && can('SITE_SOCIAL_MEDIA') || can('SOCIAL_MEDIA')">
                            <a>
                                <lang labelKey="MAIN_MENU-SOCIAL_MEDIA"></lang>
                            </a>
                        </router-link>

                    </ul>

                </router-link>

                <!-- APOPOINT for PHARMACIES -->
                <router-link tag="li" :to="{ name: 'apoApopoint' }" title="Apopoint" v-if="activeUser.site && activeUser.site.hasApoPoint">
                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-goto-cms"></i></span>
                        <lang labelKey="MAIN_MENU-APOPOINT"></lang>
                    </a>

                    <ul class="subNav">

                        <!-- APOPOINT - CMS -->
                        <router-link tag="li" :to="{ name: 'apoCMS' }" :key="'apoDefault' + activeUser.id"
                            v-if="can('APOKAT') && activeUser.site.hasApoPoint && activeUser.site.hasApoPoint == 1">
                            <a>
                                <lang labelKey="MAIN_MENU-APOPOINT-CMS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'pimProducts' }">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-PRODUCTS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'pimCampaigns' }">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-CAMPAIGNS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'pimProductGroups' }">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-PRODUCT_GROUPS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'pimSettings' }" v-if="activeUser.userRole.name == 'Administrator'">
                            <a>
                                <lang labelKey="MAIN_MENU-PIM-PHARMACY_SETTINGS"></lang>
                            </a>
                        </router-link>

                    </ul>

                </router-link>

                <!-- APOTHEKEN DATEN - MUTATIONEN -->
                <router-link tag="li" :to="{ name: 'apoHome' }" :key="'apoDefault' + activeUser.id" v-if="activeUser.site">
                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-freigaben2"></i></span>
                        <lang labelKey="MAIN_MENU-APOKAT-BASE_DATA"></lang>
                    </a>
                </router-link>

                <!-- COMPLAT -->
                <router-link tag="li" :to="{ name: 'complatDashboard' }" title="Dashboard" v-if="can('COMPLAT')">

                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-dashboard" aria-hidden="true"></i></span>
                        <lang labelKey="MAIN_MENU-COMMUNICATION_PLATTFORM"></lang>
                    </a>

                    <ul class="subNav">

                        <router-link tag="li" :to="{ name: 'complatContentPool' }" v-if="can('COMPLAT_CONTENTS')">
                            <a>
                                <lang labelKey="MAIN_MENU-CONTENT_POOL"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'complatCalendar' }" v-if="can('COMPLAT_CALENDAR')">
                            <a>
                                <lang labelKey="MAIN_MENU-CONTENT_POOL-CALENDAR"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'complatNewsletters' }" v-if="can('COMPLAT_NEWSLETTER')">
                            <a>
                                <lang labelKey="MAIN_MENU-COMPLAT-NEWSLETTER"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'complatHiPrint' }" v-if="can('HI_PRINT')">
                            <a>
                                <lang labelKey="MAIN_MENU-COMPLAT-HI_PRINT"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'complatCooperate' }" v-if="can('COOPERATE_PRINT')">
                            <a>
                                <lang labelKey="MAIN_MENU-COMPLAT-COOPERATE_PRINT"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'complatImagePool' }" v-if="can('COMPLAT_IMAGES')">
                            <a>
                                <lang labelKey="MAIN_MENU-CONTENT_POOL-IMAGES"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'complatContentPoolTopics' }" v-if="can('COMPLAT_TOPICS')">
                            <a>
                                <lang labelKey="MAIN_MENU-CONTENT_POOL-SETTINGS_TOPICS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'complatContentPoolSettings' }"
                            v-if="can('COMPLAT_SETTINGS')">
                            <a>
                                <lang labelKey="MAIN_MENU-CONTENT_POOL-SETTINGS"></lang>
                            </a>
                        </router-link>

                    </ul>

                </router-link>

                <!-- GERÄTEKATALOG -->
                <router-link tag="li" :to="{ name: 'equipmentCatalog' }" title="Gerätekatalog"
                    v-if="can('EQUIPMENT_CATALOG')">

                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-gk" aria-hidden="true"></i></span>
                        <lang labelKey="MAIN_MENU-EQUIPMENT_CATALOG"></lang>
                    </a>

                    <ul class="subNav">

                        <router-link tag="li" :to="{ name: 'equipmentCatalogSections' }"
                            v-if="can('EQUIPMENT_CATALOG_SECTIONS')">
                            <a>
                                <lang labelKey="MAIN_MENU-EQUIPMENT_CATALOG_SECTIONS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'equipments' }" v-if="can('EQUIPMENT')">
                            <a>
                                <lang labelKey="MAIN_MENU-EQUIPMENTS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'equipmentCategories' }" v-if="can('EQUIPMENT_CATEGORIES')">
                            <a>
                                <lang labelKey="MAIN_MENU-EQUIPMENT_CATEGORIES"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'equipmentOnlineCategories' }"
                            v-if="can('EQUIPMENT_ONLINE_CATEGORIES')">
                            <a>
                                <lang labelKey="MAIN_MENU-EQUIPMENT_ONLINE_CATEGORIES"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'equipmentCatalogAds' }"
                            v-if="can('EQUIPMENT_ONLINE_CATEGORIES')">
                            <a>
                                <lang labelKey="MAIN_MENU-EQUIPMENT_CATALOG_ADS"></lang>
                            </a>
                        </router-link>
                    </ul>

                </router-link>

                <!-- EINSTELLUNGEN -->
                <router-link tag="li" :to="{ name: 'settings' }" title="Einstellungen" v-if="can('SETTINGS')">

                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-einstellungen"></i></span>
                        <lang labelKey="MAIN_MENU-SETTINGS"></lang>
                    </a>

                    <ul class="subNav">

                        <router-link tag="li" :to="{ name: 'users' }" title="Benutzerverwaltung">
                            <a>
                                <lang labelKey="MAIN_MENU-USER"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'userPermissions' }">
                            <a>
                                <lang labelKey="MAIN_MENU-USER-ROLES"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'settingsInterfacesMonitoring' }">
                            <a>
                                <lang labelKey="MAIN_MENU-SETTINGS_INTERFACES_DASHBOARD"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'settingsLabels' }" v-if="can('LABELS')">
                            <a>
                                <lang labelKey="MAIN_MENU-SETTINGS_LABELS"></lang>
                            </a>
                        </router-link>

                        <router-link tag="li" :to="{ name: 'settingsEmailTemplates' }" v-if="can('MAIL_TEMPLATES')">
                            <a>
                                <lang labelKey="MAIN_MENU-SETTINGS_EMAIL_TEMPLATES"></lang>
                            </a>
                        </router-link>

                    </ul>

                </router-link>



                <!-- INDUSTRIEPARTNER NAV ITEMS -->
                <router-link tag="li" :to="{ name: 'produkte' }" title="Produkte" v-if="can('MANUFACTURER')">
                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-produkte"></i></span>
                        <lang labelKey="MAIN_MENU-INDUSTRY-PRODUCTS"></lang>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'druckfreigaben' }" title="Druckfreigaben"
                    v-if="$store.state.industryPartnerHasCatalogPage == true && can('MANUFACTURER_PRINT_APPROVAL')">
                    <a>
                        <span class="icon is-small"><i class="fa icon-ak-freigaben2"></i></span>
                        <lang labelKey="MAIN_MENU-INDUSTRY-PRINT_APPROVEMENTS"></lang>
                    </a>
                </router-link>


            </ul>



        </nav>

        <!-- MENU TOGGLER -->
        <span 
            class="open-menu pointer material-symbols-outlined" 
            @click="toggleMenu" 
            :title="isMenuOpen ? 'Menü verkleinern' : 'Menü vergrößern'">
            {{ isMenuOpen ? 'arrow_menu_close' : 'arrow_menu_open' }} 
        </span>

        <!-- VERSIONING -->
        <div id="version"><span><span class="label">MWB</span> v{{ appVersion }}</span>
            <span v-if="apiVersion"><span class="label">MWB-API</span> v{{ apiVersion }}</span>
        </div>

    </div>

</template>


<script>


export default {

    data() {
        return { 

        }
    },

    mounted() {

    },

    computed: {

        apiVersion() {
            return this.$store.getters.getApiVersion;
        },
        
        appVersion() {
            return process.env.VUE_APP_VERSION;
        },

        isMenuOpen() {
          return this.$store.getters.getMenuStatus;
        },

        homeLink() {

          switch(this.$store.getters.getUser.defaultRoute) {
            case '/kalender':
              return 'calendar'; //'/marketing-cockpit/kalender';

            default:
              return this.$store.getters.getUser.defaultRoute;
          }

        },

    },


    methods: {

        toggleMenu() {
          this.$store.commit('toggleMenuStatus')
        },

    }

}

</script>


<style lang="scss" scoped>

    .menuClosed {
        #navigation-wrapper {
            width: 43px;
            flex-basis: 43px;
            min-width: 43px;
            max-width: 43px;
        }

        #version {
            font-size: 8px;
            line-height: normal;
            gap: 8px;
            .label {
                display: inline-block;
                padding: 0;
            }
        }
    }


    .open-menu {
        margin-top: 14px;
        display: block;
        background-color: #2d293e3b;
        width: 100%;
        height: 32px;
        font-size: 14px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #bbb;
        &:hover {
            transition: all .2 ease;
            color: #FFF;
        }
    }

    #version {
        position: absolute;
        bottom: 12px;
        left: 0;
        right: 0;
        font-size: 8.5px;

        color: #BBB;
        text-align: center;
        opacity: 0.6;
        transition: all .3s ease;
        &:hover {
            opacity: 1;
        }
        display: flex;
        flex-direction: column;
        .label {
            display: inline;
            color: inherit;
            font-weight: 600;
            padding-right: 4px;
        }
    }

</style>
